export default {
  root: {
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
    justifyContent: "center",
    zIndex: 1301
  }
};
